$(document).ready(function(){
  function super_wishlist(){
    //   wishlist
    let wishlist = [];
    wishlist = JSON.parse(localStorage.getItem("wishlist"));

    let wishlist_products;

    $(document).on('click','.wishlist_btn',function () {
      let count = 0;
      var pro = $(this).attr("data-handle");
      $.getJSON("/products/" + pro + ".js",function(product){      
//         console.log(product);
        $(wishlist).each(function(i,pro1){
          if(product.id == pro1.id)
          {
            $(document).find(".product_card .wishlist_btn[data-handle="+product.handle+"]").removeClass("wishlist-added");
            $(document).find(".product .product__info-wrapper .pro_temp_wishlist_block .wishlist_btn[data-handle="+pro+"]").removeClass("wishlist-added");
            wishlist = JSON.parse(localStorage.getItem("wishlist"));
            wishlist.splice(i, 1); 
            localStorage.setItem("wishlist",JSON.stringify(wishlist));
            count++;
            update_counter();
          }

        });

        if(count == 0)
        {
          wishlist = JSON.parse(localStorage.getItem("wishlist"));
          if(wishlist == null)
          {
            localStorage.setItem("wishlist",JSON.stringify(wishlist));
            wishlist = [];
          }

          wishlist.push(product);
          localStorage.setItem("wishlist",JSON.stringify(wishlist));
          wishlist_products = JSON.parse(localStorage.getItem("wishlist"));
          $(document).find(".product_card .wishlist_btn[data-handle="+pro+"]").addClass("wishlist-added");
          $(document).find(".product .product__info-wrapper .pro_temp_wishlist_block .wishlist_btn[data-handle="+pro+"]").addClass("wishlist-added");
          update_counter();
        }      
      });
    });
    wishlist_init();

    function wishlist_init(){
      let wishlistinit = JSON.parse(localStorage.getItem("wishlist"));
      $(wishlistinit).each(function(i,product){
//         console.log(product.handle);
        $(document).find(".product_card .wishlist_btn[data-handle="+product.handle+"]").addClass("wishlist-added");
        $(document).find(".product .product__info-wrapper .pro_temp_wishlist_block .wishlist_btn[data-handle="+product.handle+"]").addClass("wishlist-added");
      });
    }

    function update_counter(){
      let wishlist = JSON.parse(localStorage.getItem("wishlist"));
      if(!wishlist)
      {
        $("header .wishlist_btn_header_count").text(0);
//         $(".mobile-nav-main .mobile-nav .resp-wishlist .counter").text(0);
      }
      else
      {
        $("header .wishlist_btn_header_count").text(wishlist.length);
//         $(".mobile-nav-main .mobile-nav .resp-wishlist .counter").text(wishlist.length);
      }
    }
    update_counter();

    $(document).on("click",".section-wishlist .wishlist-main table .wishlist-remove-pro",function(){

      let i = $(this).data("index");
      let wishlist = JSON.parse(localStorage.getItem("wishlist"));
      let id = $(this).data("id");

      if(wishlist.length > 1)
      {
        $(wishlist).each(function(j,product){
          if(product.id == id)
          {
            wishlist.splice(j, 1); 
            localStorage.setItem("wishlist",JSON.stringify(wishlist));
            $(".section-wishlist .wishlist-main table tr[data-id='"+product.id+"']").remove();
          }
        });
      }
      else
      {
        let pro = wishlist[0];
        wishlist = [];
        localStorage.setItem("wishlist",JSON.stringify(wishlist));
        $(".section-wishlist .wishlist-main table tr[data-id='"+pro.id+"']").remove();
        $(".section-wishlist .wishlist-empty").show();
        $(".section-wishlist .wishlist-header-block").hide();
      }
      update_counter();
    });
  }
  super_wishlist();
});